module.exports = __webpack_public_path__ + "static/media/howto_share_screen.72e3837b.png";